import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { Form, FormGroup, Label, Input, FormText, Button } from 'reactstrap';
import session from '../../../core/session';
import trueLogoText from '../../../assets/img/logo.svg'

import LoadingIndicator from '../../components/loading-indicator';
import { userActions, getCurrentUser } from '../../../core/users';
import { systemCheckActions } from '../../../core/systemCheck/actions';
import { HomeAuthFooter } from './HomeAuthFooter';
import { ModalMaxNormalUsers } from './ModalMaxNormalUsers';
import { ModalRegisterByInvitation } from './ModalRegisterByInvitation';
import { ModalRegisterDisabled } from './ModalRegisterDisabled';
import { ModalInactiveUser } from './ModalInactiveUser';
import { ModalPendingUser } from './ModalPendingUser';
import { api } from '../../../core/api/api-service';
import { getNavigate } from '../../../navigationService';

const RESTORE_LOGIN_STEP_KEY = 'restoreLoginStep';

const getInitialLoginStep = (user) => {
    const restoreStep = sessionStorage.getItem(RESTORE_LOGIN_STEP_KEY);
    if (restoreStep) {
        sessionStorage.removeItem(RESTORE_LOGIN_STEP_KEY);
        if (Number(restoreStep) === 2) return 2;
    }
    // Tras un login fallido mantener el formulario de credenciales
    if (user?.error) return 2;
    return 1;
};

class LoginForm extends Component {
    constructor(props) {
        super(props);
        const { user } = this.props
        this.state = {
            email: user?.email || '',
            password: '',
            errorInputs: null,
            rememberMe: false,
            step: getInitialLoginStep(user),
            showMaxUsersModal: false,
            showInvitationModal: false,
            showRegisterDisabledModal: false,
            showInactiveUserModal: false,
            showPendingUserModal: false,
            pendingResendLoading: false,
        }
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getErrorRequest = this.getErrorRequest.bind(this);
        this.goToSignIn = this.goToSignIn.bind(this);
        this.toggleMaxUsersModal = this.toggleMaxUsersModal.bind(this);
        this.toggleInvitationModal = this.toggleInvitationModal.bind(this);
        this.toggleRegisterDisabledModal = this.toggleRegisterDisabledModal.bind(this);
        this.toggleInactiveUserModal = this.toggleInactiveUserModal.bind(this);
        this.togglePendingUserModal = this.togglePendingUserModal.bind(this);
        this.handleCreateAccountClick = this.handleCreateAccountClick.bind(this);
        this.handlePendingVerificationClick = this.handlePendingVerificationClick.bind(this);
    }

    goToSignIn() {
        this.setState({ step: 2 });
    }

    toggleMaxUsersModal() {
        this.setState((prevState) => ({ showMaxUsersModal: !prevState.showMaxUsersModal }));
    }

    toggleInvitationModal() {
        this.setState((prevState) => ({ showInvitationModal: !prevState.showInvitationModal }));
    }

    toggleRegisterDisabledModal() {
        this.setState((prevState) => ({ showRegisterDisabledModal: !prevState.showRegisterDisabledModal }));
    }

    toggleInactiveUserModal() {
        this.setState((prevState) => ({ showInactiveUserModal: !prevState.showInactiveUserModal }));
    }

    togglePendingUserModal() {
        this.setState((prevState) => ({ showPendingUserModal: !prevState.showPendingUserModal }));
    }

    componentDidUpdate(prevProps) {
        const finishedLoginAttempt = prevProps.user?.isPending && !this.props.user?.isPending;
        const isInactive = this.props.user?.error?.data?.user_inactive;
        const isPendingUser = this.props.user?.error?.data?.user_pending;
        if (finishedLoginAttempt && isInactive) {
            this.setState({ showInactiveUserModal: true });
        }
        if (finishedLoginAttempt && isPendingUser) {
            this.setState({ showPendingUserModal: true });
        }
    }

    handleCreateAccountClick(e) {
        const { systemCheck } = this.props;
        if (systemCheck?.register_disabled) {
            e.preventDefault();
            this.setState({ showRegisterDisabledModal: true });
            return;
        }
        if (systemCheck?.register_by_invitation_only) {
            e.preventDefault();
            this.setState({ showInvitationModal: true });
            return;
        }
        if (systemCheck?.max_normal_users_reached) {
            e.preventDefault();
            this.setState({ showMaxUsersModal: true });
        }
    }

    async handlePendingVerificationClick(e) {
        e.preventDefault();
        const { user } = this.props;
        const tokenId = user?.error?.data?.token_id;
        const id = user?.error?.data?.id;

        if ((!tokenId && !id) || this.state.pendingResendLoading) return;

        this.setState({ pendingResendLoading: true });

        try {
            const target = tokenId ? { token_id: tokenId } : { id };
            await api.resendVerification(target);
            const query = tokenId
                ? `token_id=${encodeURIComponent(tokenId)}`
                : `id=${encodeURIComponent(id)}`;
            getNavigate()(`/confirm-register?${query}`);
        } catch (error) {
            this.setState({ pendingResendLoading: false });
        }
    }

    persistLoginStep = () => {
        sessionStorage.setItem(RESTORE_LOGIN_STEP_KEY, String(this.state.step));
    }

    componentDidMount() {
        const user = session.getRememberUser();
        if (user) {
            this.setState({
                email: user.email,
                password: user.password,
                rememberMe: !this.state.rememberMe
            })
        }
    }

    handleSubmit(e) {
        e.preventDefault()
        const { actions } = this.props;
        const { email, password, rememberMe } = this.state;

        if (this.validateForm()) {
            actions.loadUser({
                email,
                password
            });
            rememberMe ?
                session.setRememberUser({ email, password }) :
                session.deleteRememberUser();
            }
    }

    handleInputChange({ target }) {
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const { name } = target;

        this.setState({
            [name]: value
        });
    }

    validateForm = () => {
        const { email, password } = this.state;

        if (email?.length === 0 && password?.length !== 0 ) {
            this.setState({
                errorInputs: {
                    emailError: 'Email is required',
                    passwordError: ''
                }
            })
            return false;
        }
        
        if (password?.length === 0 && email?.length !== 0 ) {
            this.setState({
                errorInputs: {
                    emailError: '',
                    passwordError: 'Password is required'
                }
            })
            return false;
        }
        
        if(email?.length === 0  && password?.length === 0) {
            this.setState({
                errorInputs: {
                    emailError: 'Email is required',
                    passwordError: 'Password is required'
                }
            })
        }
        else {
            this.setState({
                errorInputs: null
            })
            return true;
        }
    }

    getErrorRequest = () => {
        const { user } = this.props
        let error = ""

        if(user?.error?.message) {
            const belong_to_current_account = user.error.data?.belong_to_current_account;
            const belongs_to_any_account = user.error.data?.belongs_to_any_account;
            const invalid_password = user.error.data?.invalid_password;

            switch(user?.error?.message) {
                case "Unauthorized":
                    if (user.error.data?.user_inactive || user.error.data?.user_pending) {
                        break;
                    }
                    if(!belongs_to_any_account) {
                        error = <FormText>
                            This email address does not exist in our system. <br/>
                            Please check your email or create a new account by clicking the button below. <br/>
                            If you experience any issues <Link to="/contact-us" onClick={this.persistLoginStep}> contact us here. </Link>
                        </FormText>
                    } else if(!belong_to_current_account && !invalid_password) {
                        error = <FormText>
                            This user does not belong to this Account. <br/>
                            <Link to="/account-information-sent"> Please click here </Link> to recieve an email with the correct account information. <br/>
                            If you experience any issues <Link to="/contact-us" onClick={this.persistLoginStep}> contact us here. </Link>
                        </FormText>
                    } else if(belong_to_current_account && invalid_password) {
                        error = <FormText>
                            The password isn't right. <br/>
                            <Link to="/forgot-password"> Please click here </Link> to recover your password. <br/>
                            If you experience any issues <Link to="/contact-us" onClick={this.persistLoginStep}> contact us here. </Link>
                        </FormText>
                    } else if(!belong_to_current_account && invalid_password) {
                        error = <FormText>
                            This user does not belong to this Account. <br/>
                            Please verify My True Advance account url or create a new user. <br/>
                            If you experience any issues <Link to="/contact-us" onClick={this.persistLoginStep}> contact us here. </Link>
                        </FormText>
                    }
                    break;

                case "validation":
                    if(user.error?.data)
                        error = Object.keys(user.error?.data).map((itemError, index) => {
                            return <FormText>{user.error?.data[itemError]}</FormText>
                        })
                    break;

                case "Request failed with status code 429":
                    error = <FormText> Too many attempts, please wait a minute and try again. </FormText>
                    break;

                default: 
                    error = <FormText> An error has occurred, please wait and try again later. </FormText>
                    break;
            }
        }

        return error
    }

    render() {
        const { email, password, errorInputs, rememberMe, step, showMaxUsersModal, showInvitationModal, showRegisterDisabledModal, showInactiveUserModal, showPendingUserModal, pendingResendLoading } = this.state;
        const { user, systemCheck } = this.props;
        const isAccountInactive = systemCheck && systemCheck.active === false;
        const showCreateUser = !isAccountInactive && (
            systemCheck?.allow_register ||
            systemCheck?.register_by_invitation_only ||
            systemCheck?.register_disabled
        );
        const registerPrompt = showCreateUser && (
            <div className="text-left">
                <Button
                    tag={Link}
                    to="/signup"
                    onClick={this.handleCreateAccountClick}
                    color='outline-green-light'
                    className='py-2 rounded-sm mb-2'
                    block
                >
                    Create a new user
                </Button>
                <p className='text-muted text-center mb-2'>
                    By creating an account, you agree to the True Advance Code of Conduct
                </p>
            </div>
        );

        return (
            <>
                <div className="content-login mb-auto pb-4">
                    <img src={trueLogoText} alt="True Advance" className='logo mb-4'/>
                    <h3 className="libre-caslon-text-regular mb-3">Get Started</h3>

                    <div className="login-steps">
                        <div className={step === 1 || isAccountInactive ? '' : 'invisible'} aria-hidden={!(step === 1 || isAccountInactive)}>
                            {isAccountInactive ? (
                                <p className="text-muted mb-0">
                                    This account is inactive.<br />
                                    If you have any questions, please <Link to="/contact-us" className="text-primary font-weight-semibold" onClick={this.persistLoginStep}>contact us here.</Link>
                                </p>
                            ) : (
                                <>
                                    <Button type="button" onClick={this.goToSignIn} color='green-light' className='py-2 rounded-sm mb-3' block>
                                        Sign in
                                    </Button>
                                    {registerPrompt}
                                </>
                            )}
                            <HomeAuthFooter className="mt-4" loginStep={isAccountInactive ? 1 : step} />
                        </div>
                        <div className={!isAccountInactive && step === 2 ? '' : 'invisible'} aria-hidden={isAccountInactive || step !== 2}>
                            <Form className="form-login">
                                <FormGroup className='mb-3'>
                                    <Label htmlFor="inputEmail">Email Address</Label>
                                    <Input type="email" onChange={this.handleInputChange} value={email} name="email" id="inputEmail" placeholder='username@mail.com' tabIndex={!isAccountInactive && step === 2 ? 0 : -1} />
                                    {errorInputs && <FormText>{errorInputs.emailError}</FormText>}
                                </FormGroup>
                                <FormGroup className='mb-3'>
                                    <Label htmlFor="inputPassword">Password</Label>
                                    <Input type="password" onChange={this.handleInputChange} value={password} name="password" id="inputPassword" tabIndex={!isAccountInactive && step === 2 ? 0 : -1} />
                                    {errorInputs && <FormText>{errorInputs.passwordError}</FormText>}
                                    {user?.error?.message && this.getErrorRequest()}
                                </FormGroup>
                                <FormGroup check className="mb-3">
                                    <Label check>
                                        <Input type="checkbox" name="rememberMe" value={rememberMe} onChange={this.handleInputChange} tabIndex={!isAccountInactive && step === 2 ? 0 : -1} />{' '}Remember me
                                    </Label>
                                </FormGroup>
                                <Button type="submit" onClick={this.handleSubmit} color='green-light' className='py-2 rounded-sm mb-3' block tabIndex={!isAccountInactive && step === 2 ? 0 : -1}>Sign in</Button>
                                <p className="text-center mb-3">
                                    <Link to={'/forgot-password'} className="text-reset" tabIndex={!isAccountInactive && step === 2 ? 0 : -1}>Forgot Password?</Link>
                                </p>
                            </Form>
                            {registerPrompt}
                            <HomeAuthFooter className="mt-4" loginStep={step} />
                        </div>
                    </div>
                </div>

                <ModalMaxNormalUsers isOpen={showMaxUsersModal} toggle={this.toggleMaxUsersModal} />
                <ModalRegisterByInvitation isOpen={showInvitationModal} toggle={this.toggleInvitationModal} />
                <ModalRegisterDisabled isOpen={showRegisterDisabledModal} toggle={this.toggleRegisterDisabledModal} />
                <ModalInactiveUser isOpen={showInactiveUserModal} toggle={this.toggleInactiveUserModal} />
                <ModalPendingUser
                    isOpen={showPendingUserModal}
                    toggle={this.togglePendingUserModal}
                    onCompleteSetup={this.handlePendingVerificationClick}
                />
                {(user.isPending || pendingResendLoading) && <LoadingIndicator />}
            </>
        )
    }
}

//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {

    return {
        checked: state.user.checked,
        user: state.user,
        systemCheck: state.systemCheck && state.systemCheck.data && state.systemCheck.data.data
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(userActions, dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginForm);
